import { IHoliday } from '@constants/holidays/holidayTypes';
import { formatDate } from '../DateHelper';
import TranslateNew from "@translate/TranslateNew";

const tn:TranslateNew = TranslateNew.getInstance();

// This method creates the date text for each day (e.g 'Nov 1', '4', or 'Dec 35 Julafton' etc)
const generateDays  = (year: number, month: number, weeks: number, holidays: {[date: string]: IHoliday}, localization:'se'|'en') => {
  let date = new Date('2024-02-01');
  date.setFullYear(year);
  date.setMonth(month);
  while (date.getDay() !== (localization==='se'?1:0)) {
    date = new Date(date.getTime() - 86400000);
  }
  const days = [];
  let daysMade = 0;
  while (daysMade < weeks * 7) {
    let display = '';
    if (daysMade === 0 || date.getDate() === 1) {
      switch (date.getMonth()) {
        case 0:
          display = `${tn.lang.januaryShort} `;
          break;
        case 1:
          display = `${tn.lang.februaryShort} `;
          break;
        case 2:
          display = `${tn.lang.marchShort} `;
          break;
        case 3:
          display = `${tn.lang.aprilShort} `;
          break;
        case 4:
          display = `${tn.lang.mayShort} `;
          break;
        case 5:
          display = `${tn.lang.juneShort} `;
          break;
        case 6:
          display = `${tn.lang.julyShort} `;
          break;
        case 7:
          display = `${tn.lang.augustShort} `;
          break;
        case 8:
          display = `${tn.lang.septemberShort} `;
          break;
        case 9:
          display = `${tn.lang.octoberShort} `;
          break;
        case 10:
          display = `${tn.lang.novemberShort} `;
          break;
        case 11:
          display = `${tn.lang.decemberShort} `;
          break;
      }
    }
    display = display + date.getDate();
    const day: {date:string, color:boolean, display:string, dateObject:Date, dayType:"normalDay"|"otherMonthWknd"|"otherMonth"|"sunday"|"saturday"} 
      = { date: formatDate(date), color:false, display, dateObject:date, dayType:"normalDay"};
    if (holidays[day.date]) {
      display = display + ' ' + holidays[day.date].title;
      day.color = true;
    }
    else if (date.getDay() === 0 || date.getDay() === 6) {
      day.color = true;
    }
    let dayType:"normalDay"|"otherMonthWknd"|"otherMonth"|"sunday"|"saturday" = "normalDay";
    if (date.getMonth() !== month && weeks < 7 && (date.getDay() === 0 || date.getDay() === 6)) {
      dayType = "otherMonthWknd";
    } else if (date.getMonth() !== month && weeks < 7) {
      dayType = "otherMonth";
    } else if (holidays[day.date] || date.getDay() === 0) {
      dayType = "sunday";
    } else if (date.getDay() === 6) {
      dayType = "saturday";
    } 

    day.display = display;
    day.dateObject = date;
    day.dayType = dayType;
    days.push(day);
    

    daysMade++;
    date = new Date(date.getTime() + 86400000);
  }

  return days;
};

export { generateDays };



// WEBPACK FOOTER //
// ./src/helpers/calendar/Generator.tsx